"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingTable = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const compliance_pool_types_1 = require("../../compliance-pool-types");
const common_styled_components_1 = require("../../../common-styled-components");
const react_1 = require("react");
const theme_1 = require("../../../../theme");
const useEdit_1 = __importDefault(require("../../../../hooks/useEdit"));
const amountUtils_1 = require("../../../../util/amountUtils");
const Modal_1 = require("../Modal");
const useSortedData_1 = require("../../../../hooks/useSortedData");
const lodash_1 = require("lodash");
const YearContext_1 = require("../../../../contexts/YearContext");
const isNullish_1 = require("../../../../util/isNullish");
const ExportCsvButton_1 = require("../ExportCsvButton");
const tableColumns = (showPool, isInAdminTools) => {
    const columns = [
        {
            key: "created_at",
            label: "Created",
            sortableKey: "created_at",
        },
        {
            key: showPool ? "pool" : "company",
            label: showPool ? "Pool" : "Company",
        },
        {
            key: "year",
            label: "Year",
        },
        {
            key: "quantity_tco2e",
            label: "Quantity (tCO₂e)",
            sortableKey: "quantity_tco2e",
        },
    ];
    if (isInAdminTools) {
        columns.push({
            key: "tools",
            label: "Tools",
        });
    }
    return columns;
};
const CellContent = ({ booking, contentKey, isInAdminTools, removeBooking, }) => {
    switch (contentKey) {
        case "quantity_tco2e":
            return (0, jsx_runtime_1.jsx)("div", { children: (0, amountUtils_1.formatNumber)(booking.quantity_tco2e) });
        case "company":
            return (0, jsx_runtime_1.jsx)("div", { children: booking.company.name });
        case "pool":
            return (0, jsx_runtime_1.jsx)("div", { children: booking.pool.name });
        case "tools":
            return isInAdminTools ? ((0, jsx_runtime_1.jsx)(common_styled_components_1.Row, { children: (0, jsx_runtime_1.jsx)(common_styled_components_1.SmallButton, { onClick: () => removeBooking(booking), children: "Remove" }) })) : ((0, jsx_runtime_1.jsx)("div", {}));
        default:
            return (0, jsx_runtime_1.jsx)("div", { children: booking[contentKey] });
    }
};
const BookingTable = ({ bookings, isInAdminTools, pool, companyId, refresh, }) => {
    const { selectedYear } = (0, YearContext_1.useYear)();
    const [modal, setModal] = (0, react_1.useState)({});
    const { sortedData, sortMethod, sortDirection, setSort } = (0, useSortedData_1.useSortedData)(bookings, "created_at", -1);
    const toggleBookingModal = () => {
        if (modal.type !== undefined) {
            setModal({});
        }
        else {
            setModal({
                type: "add",
                value: {
                    year: selectedYear,
                    pool_id: pool?.id ?? undefined,
                    company_id: companyId ?? undefined,
                },
            });
        }
    };
    const [editStatus, executeEdit] = (0, useEdit_1.default)("admin/pool_booking.json", refresh);
    const removeBooking = (booking) => {
        setModal({
            type: "remove",
            value: {
                id: booking.id,
            },
        });
    };
    const submit = (type, value) => {
        setModal({});
        const bookingInput = (0, lodash_1.pick)(value, compliance_pool_types_1.bookingInputKeys);
        if (type === "add") {
            if ((0, compliance_pool_types_1.isValidBookingInput)(bookingInput)) {
                const data = (0, lodash_1.pickBy)({
                    ...bookingInput,
                }, (_, key) => key !== "id");
                executeEdit(data, "PUT");
            }
        }
        if (type === "remove") {
            if (value.id !== undefined) {
                const data = {
                    id: value.id,
                };
                executeEdit(data, "DELETE");
            }
        }
    };
    const columns = tableColumns((0, isNullish_1.isNullish)(pool), isInAdminTools);
    const csvColumns = columns
        .filter((column) => column.key !== "tools")
        .map((column) => ({
        header: column.label,
        getValue: (booking) => {
            switch (column.key) {
                case "quantity_tco2e":
                    return (0, amountUtils_1.formatNumber)(booking.quantity_tco2e) ?? "";
                case "company":
                    return booking.company.name;
                case "pool":
                    return booking.pool.name;
                case "tools":
                    return "";
                default:
                    return booking[column.key] ?? "";
            }
        },
    }));
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Modal_1.Modal, { type: "booking", isOpen: modal.type !== undefined, closeModal: () => setModal({}), modalType: modal.type, value: modal.value, submit: submit, pool: pool ?? undefined, companyId: companyId ?? undefined }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Row, { gap: 2, children: [isInAdminTools && ((0, jsx_runtime_1.jsx)(common_styled_components_1.SecondaryButton, { color: theme_1.theme.colors.blue, onClick: () => toggleBookingModal(), children: "+ Add booking" })), (0, jsx_runtime_1.jsx)(ExportCsvButton_1.ExportCsvButton, { rows: sortedData, columns: csvColumns, tableName: "bookings" })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Table, { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsx)("tr", { children: columns.map((c) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.SortableTH, { setSort: setSort, sortKey: c.sortableKey, sortDirection: sortMethod && sortMethod === c.sortableKey
                                    ? sortDirection
                                    : undefined, children: c.label }, c.key))) }) }), (0, jsx_runtime_1.jsx)("tbody", { children: sortedData.map((booking) => {
                            return ((0, jsx_runtime_1.jsx)(common_styled_components_1.TR, { children: columns.map((c) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.TD, { children: (0, jsx_runtime_1.jsx)(CellContent, { contentKey: c.key, booking: booking, isInAdminTools: isInAdminTools, removeBooking: removeBooking }) }, c.key))) }, booking.id));
                        }) })] })] }));
};
exports.BookingTable = BookingTable;
